import React from 'react';

class AnchorSection extends React.Component {
    render () {
        return (
            <div className={['component-anchor-section', this.props.className].join(' ')}>
                <div id={this.props.id} className="anchor-section-target"></div>
                { this.props.children }
            </div>
        )
    }
}

export default AnchorSection;



// WEBPACK FOOTER //
// ./web-app/components/anchor-section.jsx